<mat-card>
  <mat-card-content>
    <h1>Password Reset</h1>

    <form [formGroup]="resetGroup">
      <mat-form-field appearance="outline">
        <mat-label>New Password</mat-label>
        <input matInput type="password" placeholder="Password" formControlName="password" />
        <mat-hint>Password must be at least 16 characters</mat-hint>
        <mat-error>
          @if (resetGroup.get('password')?.hasError('required')) {
            <span>Password is required</span>
          }
          @if (resetGroup.get('password')?.hasError('passwordComplexity')) {
            <span>{{ resetGroup.get('password')?.getError('passwordComplexity') }}</span>
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Confirm Password</mat-label>
        <input matInput type="password" placeholder="Confirm Password" formControlName="confirmPassword">
        <mat-error>
          @if (resetGroup.get('confirmPassword')?.hasError('required')) {
            <span>Confirm password is required</span>
          }
          @if (resetGroup.get('confirmPassword')?.hasError('match')) {
            <span>Passwords must match</span>
          }
        </mat-error>
      </mat-form-field>
    </form>
  </mat-card-content>

  <mat-card-footer>
    <button
      class="wide"
      type="submit"
      [disabled]="resetGroup.invalid || resetGroup.pending"
      mat-flat-button
      color="primary"
      (click)="changePassword()">
      Change Password
    </button>
  </mat-card-footer>
</mat-card>
